/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContentLayout = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M1 22h6V9H1zm2-11h2v9H3zm5 11h15V9H8zm2-11h11v9H10zM1 8h6V2H1zm2-4h2v2H3zm5-2v6h15V2zm13 4H10V4h11z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgContentLayout as ContentLayout };
